export default {
  props: {
    columns: {
      type: Array,
      required: true,
    },
    withPlaceholder: {
      type: Boolean,
      default: true,
    },
    placeholderLabel: {
      type: String,
      default: null,
    },
    value: {
      type: String,
      default: null,
    },
  },
  computed: {
    columnsWithOrders() {
      let arr = [];
      this.columns.forEach((column) => {
        ['ASC', 'DESC'].forEach((direction) => {
          arr.push({
            value: column.slug + ':' + direction,
            label: column.label + (direction === 'ASC' ? ' &dtrif;' : ' &utrif;'),
          });
        });
      });

      return arr;
    },
    selected() {
      if (this.hasProp('value')) {
        return this.value;
      }

      if (!this.$store.state.grid.order) {
        return null;
      }

      return this.$store.state.grid.order + ':' + this.$store.state.grid.direction;
    }
  },
  methods: {
    isSelected(value) {
      if (!this.selected) {
        return false;
      }

      return this.selected.toUpperCase() === value.toUpperCase();
    },
    fireChange(e) {
      let order = e.target.value;
      if (!order) {
        this.$store.commit('grid/resetOrder');
      } else {
        let [column, direction] = order.split(':');

        this.$store.commit('grid/setOrder', {column: column, direction: direction});
      }
    },
  },
}



// WEBPACK FOOTER //
// ./public/themes/frontend/uikit3/assets/js/theme-mixins/DataGridOrders.js